import React from 'react';
import { callWith } from '../../../../util';
import Text from '../../text';
import cx from 'classnames';
import { makeStyles } from '../../../theme';
import Box, {HORIZONTAL} from '../box';

const styles = makeStyles(
	({ palette, spacing }) => ({
		choicecontainer: {
			alignItems: 'center'
		},
		choiceitem: {
			cursor: 'pointer',
			color:palette.text.headline
		},
		selected: {
			color: palette.primary.main,
			borderBottom: "2px solid"
		},
		divider: {
			color: palette.primary.main,
			marginLeft:spacing(1),
			marginRight:spacing(1)
		},
		content: {
			paddingTop:spacing(2)
		}
	})
);


const ChoiceTab = React.memo(({option, variant="h6", selected, ...props}) => {
	const classes = styles();
	return (
		<Text 
			{...props} 
			variant={variant} 
			component="span" 
			className={cx(classes.choiceitem, selected && classes.selected )}
			>
			{option.label}
		</Text>
	);
});

const ChoiceBox = React.memo(({options = [], children}) => {
	const classes = styles();
	const [selectedIndex, setSelectedIndex] = React.useState(0);
	const availableChildren = React.Children.toArray(children);
	const currentChildren = availableChildren[selectedIndex];	
	return (
		<Box>
			<Box type={HORIZONTAL} className={classes.choicecontainer}>{
				options.map((option, i) => 
					<React.Fragment key={`link-${i}`} >
						<ChoiceTab 
							id={option.id}
							selected={i===selectedIndex} 
							option={option} 
							onClick={callWith(setSelectedIndex, i)}
							/>
						{(i < options.length - 1) && (
							<span className={classes.divider}>|</span>
						)}
					</React.Fragment>
				)}</Box>
			<Box className={cx(classes.content)}>{currentChildren}</Box>
		</Box>
	);
});

export default ChoiceBox;